/******PageProjet******/

/*PAGE*/
export default function Newsletter() {
  /*DOM*/
  return (
    <>
      <meta charSet="UTF-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      <title>Newsletter SNAP</title>
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            "\n\t\tp{\n\t\t\tmargin:10px 0;\n\t\t\tpadding:0;\n\t\t}\n\t\ttable{\n\t\t\tborder-collapse:collapse;\n\t\t}\n\t\th1,h2,h3,h4,h5,h6{\n\t\t\tdisplay:block;\n\t\t\tmargin:0;\n\t\t\tpadding:0;\n\t\t}\n\t\timg,a img{\n\t\t\tborder:0;\n\t\t\theight:auto;\n\t\t\toutline:none;\n\t\t\ttext-decoration:none;\n\t\t}\n\t\tbody,#bodyTable,#bodyCell{\n\t\t\theight:100%;\n\t\t\tmargin:0;\n\t\t\tpadding:0;\n\t\t\twidth:100%;\n\t\t}\n\t\t.mcnPreviewText{\n\t\t\tdisplay:none !important;\n\t\t}\n\t\t#outlook a{\n\t\t\tpadding:0;\n\t\t}\n\t\timg{\n\t\t\t-ms-interpolation-mode:bicubic;\n\t\t}\n\t\ttable{\n\t\t\tmso-table-lspace:0pt;\n\t\t\tmso-table-rspace:0pt;\n\t\t}\n\t\t.ReadMsgBody{\n\t\t\twidth:100%;\n\t\t}\n\t\t.ExternalClass{\n\t\t\twidth:100%;\n\t\t}\n\t\tp,a,li,td,blockquote{\n\t\t\tmso-line-height-rule:exactly;\n\t\t}\n\t\ta[href^=tel],a[href^=sms]{\n\t\t\tcolor:inherit;\n\t\t\tcursor:default;\n\t\t\ttext-decoration:none;\n\t\t}\n\t\tp,a,li,td,body,table,blockquote{\n\t\t\t-ms-text-size-adjust:100%;\n\t\t\t-webkit-text-size-adjust:100%;\n\t\t}\n\t\t.ExternalClass,.ExternalClass p,.ExternalClass td,.ExternalClass div,.ExternalClass span,.ExternalClass font{\n\t\t\tline-height:100%;\n\t\t}\n\t\ta[x-apple-data-detectors]{\n\t\t\tcolor:inherit !important;\n\t\t\ttext-decoration:none !important;\n\t\t\tfont-size:inherit !important;\n\t\t\tfont-family:inherit !important;\n\t\t\tfont-weight:inherit !important;\n\t\t\tline-height:inherit !important;\n\t\t}\n\t\ttable[align=left]{\n\t\t\tfloat:left;\n\t\t}\n\t\ttable[align=right]{\n\t\t\tfloat:right;\n\t\t}\n\t\t#bodyCell{\n\t\t\tpadding:10px;\n\t\t\tborder-top:0;\n\t\t}\n\t\t.templateContainer{\n\t\t\tmax-width:600px !important;\n\t\t\tborder:0;\n\t\t}\n\t\ta.mcnButton{\n\t\t\tdisplay:block;\n\t\t}\n\t\t.mcnImage,.mcnRetinaImage{\n\t\t\tvertical-align:bottom;\n\t\t}\n\t\t.mcnTextContent{\n\t\t\tword-break:break-word;\n\t\t}\n\t\t.mcnTextContent img{\n\t\t\theight:auto !important;\n\t\t}\n\t\t.mcnDividerBlock{\n\t\t\ttable-layout:fixed !important;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Background Style\n\t@tip Set the background color and top border for your email. You may want to choose colors that match your company's branding.\n\t*/\n\t\tbody,#bodyTable{\n\t\t\t/*@editable*/background-color:#ececec;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Background Style\n\t@tip Set the background color and top border for your email. You may want to choose colors that match your company's branding.\n\t*/\n\t\t#bodyCell{\n\t\t\t/*@editable*/border-top:0;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Email Border\n\t@tip Set the border for your email.\n\t*/\n\t\t.templateContainer{\n\t\t\t/*@editable*/border:0;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Heading 1\n\t@tip Set the styling for all first-level headings in your emails. These should be the largest of your headings.\n\t@style heading 1\n\t*/\n\t\th1{\n\t\t\t/*@editable*/color:#21759c;\n\t\t\t/*@editable*/font-family:'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif;\n\t\t\t/*@editable*/font-size:26px;\n\t\t\t/*@editable*/font-style:normal;\n\t\t\t/*@editable*/font-weight:bold;\n\t\t\t/*@editable*/line-height:125%;\n\t\t\t/*@editable*/letter-spacing:normal;\n\t\t\t/*@editable*/text-align:justify;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Heading 2\n\t@tip Set the styling for all second-level headings in your emails.\n\t@style heading 2\n\t*/\n\t\th2{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:22px;\n\t\t\t/*@editable*/font-style:normal;\n\t\t\t/*@editable*/font-weight:bold;\n\t\t\t/*@editable*/line-height:125%;\n\t\t\t/*@editable*/letter-spacing:normal;\n\t\t\t/*@editable*/text-align:justify;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Heading 3\n\t@tip Set the styling for all third-level headings in your emails.\n\t@style heading 3\n\t*/\n\t\th3{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:20px;\n\t\t\t/*@editable*/font-style:normal;\n\t\t\t/*@editable*/font-weight:bold;\n\t\t\t/*@editable*/line-height:125%;\n\t\t\t/*@editable*/letter-spacing:normal;\n\t\t\t/*@editable*/text-align:justify;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Heading 4\n\t@tip Set the styling for all fourth-level headings in your emails. These should be the smallest of your headings.\n\t@style heading 4\n\t*/\n\t\th4{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:18px;\n\t\t\t/*@editable*/font-style:normal;\n\t\t\t/*@editable*/font-weight:bold;\n\t\t\t/*@editable*/line-height:125%;\n\t\t\t/*@editable*/letter-spacing:normal;\n\t\t\t/*@editable*/text-align:justify;\n\t\t}\n\t/*\n\t@tab Preheader\n\t@section Preheader Style\n\t@tip Set the background color and borders for your email's preheader area.\n\t*/\n\t\t#templatePreheader{\n\t\t\t/*@editable*/background-color:#ffffff;\n\t\t\t/*@editable*/background-image:none;\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:0;\n\t\t\t/*@editable*/padding-top:0px;\n\t\t\t/*@editable*/padding-bottom:0px;\n\t\t}\n\t/*\n\t@tab Preheader\n\t@section Preheader Text\n\t@tip Set the styling for your email's preheader text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templatePreheader .mcnTextContent,#templatePreheader .mcnTextContent p{\n\t\t\t/*@editable*/color:#656565;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:12px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:center;\n\t\t}\n\t/*\n\t@tab Preheader\n\t@section Preheader Link\n\t@tip Set the styling for your email's preheader links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templatePreheader .mcnTextContent a,#templatePreheader .mcnTextContent p a{\n\t\t\t/*@editable*/color:#656565;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t/*\n\t@tab Header\n\t@section Header Style\n\t@tip Set the background color and borders for your email's header area.\n\t*/\n\t\t#templateHeader{\n\t\t\t/*@editable*/background-color:#ffffff;\n\t\t\t/*@editable*/background-image:none;\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:0;\n\t\t\t/*@editable*/padding-top:0px;\n\t\t\t/*@editable*/padding-bottom:0px;\n\t\t}\n\t/*\n\t@tab Header\n\t@section Header Text\n\t@tip Set the styling for your email's header text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templateHeader .mcnTextContent,#templateHeader .mcnTextContent p{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:16px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:justify;\n\t\t}\n\t/*\n\t@tab Header\n\t@section Header Link\n\t@tip Set the styling for your email's header links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templateHeader .mcnTextContent a,#templateHeader .mcnTextContent p a{\n\t\t\t/*@editable*/color:#007C89;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t/*\n\t@tab Body\n\t@section Body Style\n\t@tip Set the background color and borders for your email's body area.\n\t*/\n\t\t#templateBody{\n\t\t\t/*@editable*/background-color:#ffffff;\n\t\t\t/*@editable*/background-image:url(\"https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/c177e0ce-9867-d418-241f-024ff3891fca.jpg\");\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:2px solid #EAEAEA;\n\t\t\t/*@editable*/padding-top:0;\n\t\t\t/*@editable*/padding-bottom:9px;\n\t\t}\n\t/*\n\t@tab Body\n\t@section Body Text\n\t@tip Set the styling for your email's body text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templateBody .mcnTextContent,#templateBody .mcnTextContent p{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:16px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:justify;\n\t\t}\n\t/*\n\t@tab Body\n\t@section Body Link\n\t@tip Set the styling for your email's body links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templateBody .mcnTextContent a,#templateBody .mcnTextContent p a{\n\t\t\t/*@editable*/color:#007C89;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t/*\n\t@tab Footer\n\t@section Footer Style\n\t@tip Set the background color and borders for your email's footer area.\n\t*/\n\t\t#templateFooter{\n\t\t\t/*@editable*/background-color:#ffffff;\n\t\t\t/*@editable*/background-image:none;\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:0;\n\t\t\t/*@editable*/padding-top:9px;\n\t\t\t/*@editable*/padding-bottom:9px;\n\t\t}\n\t/*\n\t@tab Footer\n\t@section Footer Text\n\t@tip Set the styling for your email's footer text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templateFooter .mcnTextContent,#templateFooter .mcnTextContent p{\n\t\t\t/*@editable*/color:#656565;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:12px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:center;\n\t\t}\n\t/*\n\t@tab Footer\n\t@section Footer Link\n\t@tip Set the styling for your email's footer links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templateFooter .mcnTextContent a,#templateFooter .mcnTextContent p a{\n\t\t\t/*@editable*/color:#656565;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t@media only screen and (min-width:768px){\n\t\t.templateContainer{\n\t\t\twidth:600px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\tbody,table,td,p,a,li,blockquote{\n\t\t\t-webkit-text-size-adjust:none !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\tbody{\n\t\t\twidth:100% !important;\n\t\t\tmin-width:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnRetinaImage{\n\t\t\tmax-width:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImage{\n\t\t\twidth:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnCartContainer,.mcnCaptionTopContent,.mcnRecContentContainer,.mcnCaptionBottomContent,.mcnTextContentContainer,.mcnBoxedTextContentContainer,.mcnImageGroupContentContainer,.mcnCaptionLeftTextContentContainer,.mcnCaptionRightTextContentContainer,.mcnCaptionLeftImageContentContainer,.mcnCaptionRightImageContentContainer,.mcnImageCardLeftTextContentContainer,.mcnImageCardRightTextContentContainer,.mcnImageCardLeftImageContentContainer,.mcnImageCardRightImageContentContainer{\n\t\t\tmax-width:100% !important;\n\t\t\twidth:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnBoxedTextContentContainer{\n\t\t\tmin-width:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageGroupContent{\n\t\t\tpadding:9px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnCaptionLeftContentOuter .mcnTextContent,.mcnCaptionRightContentOuter .mcnTextContent{\n\t\t\tpadding-top:9px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageCardTopImageContent,.mcnCaptionBottomContent:last-child .mcnCaptionBottomImageContent,.mcnCaptionBlockInner .mcnCaptionTopContent:last-child .mcnTextContent{\n\t\t\tpadding-top:18px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageCardBottomImageContent{\n\t\t\tpadding-bottom:9px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageGroupBlockInner{\n\t\t\tpadding-top:0 !important;\n\t\t\tpadding-bottom:0 !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageGroupBlockOuter{\n\t\t\tpadding-top:9px !important;\n\t\t\tpadding-bottom:9px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnTextContent,.mcnBoxedTextContentColumn{\n\t\t\tpadding-right:18px !important;\n\t\t\tpadding-left:18px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageCardLeftImageContent,.mcnImageCardRightImageContent{\n\t\t\tpadding-right:18px !important;\n\t\t\tpadding-bottom:0 !important;\n\t\t\tpadding-left:18px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcpreview-image-uploader{\n\t\t\tdisplay:none !important;\n\t\t\twidth:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Heading 1\n\t@tip Make the first-level headings larger in size for better readability on small screens.\n\t*/\n\t\th1{\n\t\t\t/*@editable*/font-size:22px !important;\n\t\t\t/*@editable*/line-height:125% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Heading 2\n\t@tip Make the second-level headings larger in size for better readability on small screens.\n\t*/\n\t\th2{\n\t\t\t/*@editable*/font-size:20px !important;\n\t\t\t/*@editable*/line-height:125% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Heading 3\n\t@tip Make the third-level headings larger in size for better readability on small screens.\n\t*/\n\t\th3{\n\t\t\t/*@editable*/font-size:18px !important;\n\t\t\t/*@editable*/line-height:125% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Heading 4\n\t@tip Make the fourth-level headings larger in size for better readability on small screens.\n\t*/\n\t\th4{\n\t\t\t/*@editable*/font-size:16px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Boxed Text\n\t@tip Make the boxed text larger in size for better readability on small screens. We recommend a font size of at least 16px.\n\t*/\n\t\t.mcnBoxedTextContentContainer .mcnTextContent,.mcnBoxedTextContentContainer .mcnTextContent p{\n\t\t\t/*@editable*/font-size:14px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Preheader Visibility\n\t@tip Set the visibility of the email's preheader on small screens. You can hide it to save space.\n\t*/\n\t\t#templatePreheader{\n\t\t\t/*@editable*/display:block !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Preheader Text\n\t@tip Make the preheader text larger in size for better readability on small screens.\n\t*/\n\t\t#templatePreheader .mcnTextContent,#templatePreheader .mcnTextContent p{\n\t\t\t/*@editable*/font-size:14px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Header Text\n\t@tip Make the header text larger in size for better readability on small screens.\n\t*/\n\t\t#templateHeader .mcnTextContent,#templateHeader .mcnTextContent p{\n\t\t\t/*@editable*/font-size:16px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Body Text\n\t@tip Make the body text larger in size for better readability on small screens. We recommend a font size of at least 16px.\n\t*/\n\t\t#templateBody .mcnTextContent,#templateBody .mcnTextContent p{\n\t\t\t/*@editable*/font-size:16px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Footer Text\n\t@tip Make the footer content text larger in size for better readability on small screens.\n\t*/\n\t\t#templateFooter .mcnTextContent,#templateFooter .mcnTextContent p{\n\t\t\t/*@editable*/font-size:14px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}",
        }}
      />
      {/**|IF:MC_PREVIEW_TEXT|**/}
      {/*[if !gte mso 9]><!--*/}
      <span
        className="mcnPreviewText"
        style={{
          display: "none",
          fontSize: 0,
          lineHeight: 0,
          maxHeight: 0,
          maxWidth: 0,
          opacity: 0,
          overflow: "hidden",
          visibility: "hidden",
          msoHide: "all",
        }}
      >
        *|MC_PREVIEW_TEXT|*
      </span>
      {/*<![endif]*/}
      {/**|END:IF|**/}
      <center>
        <table
          align="center"
          border={0}
          cellPadding={0}
          cellSpacing={0}
          height="100%"
          width="100%"
          id="bodyTable"
        >
          <tbody>
            <tr>
              <td align="center" valign="top" id="bodyCell">
                {/* BEGIN TEMPLATE // */}
                {/*[if (gte mso 9)|(IE)]>
                  <table align="center" border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">
                  <tr>
                  <td align="center" valign="top" width="600" style="width:600px;">
                  <![endif]*/}
                <table
                  border={0}
                  cellPadding={0}
                  cellSpacing={0}
                  width="100%"
                  className="templateContainer"
                >
                  <tbody>
                    <tr>
                      <td valign="top" id="templatePreheader" />
                    </tr>
                    <tr>
                      <td valign="top" id="templateHeader">
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnImageBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnImageBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                style={{ padding: 9 }}
                                className="mcnImageBlockInner"
                              >
                                <table
                                  align="left"
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnImageContentContainer"
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="mcnImageContent"
                                        valign="top"
                                        style={{
                                          paddingRight: 9,
                                          paddingLeft: 9,
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          align="center"
                                          alt=""
                                          src="https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/6e0046ea-0c49-0e59-bc86-bfc5627b665b.png"
                                          width="270.71999999999997"
                                          style={{
                                            maxWidth: 4266,
                                            paddingBottom: 0,
                                            display: "inline !important",
                                            verticalAlign: "bottom",
                                          }}
                                          className="mcnImage"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnCodeBlock"
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td valign="top" className="mcnTextBlockInner">
                                <div
                                  className="mcnTextContent"
                                  style={{
                                    display: "flex!important",
                                    justifyContent: "flex-end!important",
                                  }}
                                >
                                  <h2
                                    style={{
                                      width: "150px!important",
                                      padding: 5,
                                      pointerEvent: "none!important",
                                      textAlign: "center!important",
                                      textDecoration: "unset!important",
                                      maxWidth: "150px!important",
                                      display: "flex!important",
                                      justifyContent: "center!important",
                                      fontFamily: '"helvetica"!important',
                                      fontSize: "18px!important",
                                      color: "#21759c!important",
                                      borderRadius: "5px 5px 0 0!important",
                                      border: "2px solid #21759c",
                                    }}
                                  >
                                    Avril 2026
                                  </h2>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top" id="templateBody">
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnCodeBlock"
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td valign="top" className="mcnTextBlockInner">
                                <div className="mcnTextContent">
                                  <h2
                                    style={{
                                      textAling: "left",
                                      fontFamily: '"helvetica"',
                                      textTransform: "uppercase",
                                      color: "white",
                                      backgroundColor: "#21759c",
                                      padding: "7px 7px 7px 15px",
                                      boxShadow: "0 2px 10px -5px black",
                                    }}
                                  >
                                    Plateforme immersive en réalité virtuelle
                                  </h2>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p style={{ textAlign: "justify" }}>
                                            <span style={{ color: "#e84e24" }}>
                                              <strong>
                                                <span style={{ fontSize: 19 }}>
                                                  En complément des cours
                                                  proposés sur la plateforme
                                                  immersive en réalité
                                                  virtuelle, le SNAP a récemment
                                                  déployé plusieurs actions au
                                                  croisement de la pédagogie et
                                                  de la sensibilisation :&nbsp;
                                                </span>
                                              </strong>
                                            </span>
                                          </p>
                                          <p
                                            paraeid="{dd4eb9d3-0761-4f69-9f5a-7955e8895156}{75}"
                                            paraid={1183201897}
                                            style={{ textAlign: "center" }}
                                          >
                                            &nbsp;
                                            <strong>
                                              Une première à Nîmes Université :
                                              un cours d’économie en réalité
                                              virtuelle
                                            </strong>
                                          </p>
                                          <p
                                            paraeid="{dd4eb9d3-0761-4f69-9f5a-7955e8895156}{75}"
                                            paraid={1183201897}
                                          >
                                            Mené en collaboration avec Laetitia
                                            Tuffery auprès d’une classe de L2
                                            AES, ce projet inédit a plongé les
                                            étudiants au cœur de la prise de
                                            décision publique. Pendant trois
                                            heures, immergés dans Cities VR, ils
                                            ont endossé le rôle de membres d’un
                                            conseil municipal, avec pour mission
                                            de développer leur ville selon
                                            différentes priorités : performance
                                            économique, transition écologique ou
                                            bien-être des habitants.
                                            <br />
                                            &nbsp;
                                            <br />
                                            <strong>Résultat : </strong>une
                                            implication renforcée, des débats
                                            animés et une compréhension concrète
                                            de notions clés comme les
                                            externalités ou la coopération. Une
                                            expérience qui démontre, une fois
                                            encore, tout le potentiel de la
                                            réalité virtuelle pour réinventer
                                            les pratiques pédagogiques et
                                            stimuler l’apprentissage.
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnImageBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnImageBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                style={{ padding: 9 }}
                                className="mcnImageBlockInner"
                              >
                                <table
                                  align="left"
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnImageContentContainer"
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="mcnImageContent"
                                        valign="top"
                                        style={{
                                          paddingRight: 9,
                                          paddingLeft: 9,
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          align="center"
                                          alt=""
                                          src="https://mcusercontent.com/7f501c761d1bd8cec028280a2/_compresseds/cd8a84a0-776e-db1a-4427-bd400972c521.jpg"
                                          width={564}
                                          style={{
                                            maxWidth: 4240,
                                            paddingBottom: 0,
                                            display: "inline !important",
                                            verticalAlign: "bottom",
                                          }}
                                          className="mcnImage"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p
                                            paraeid="{dd4eb9d3-0761-4f69-9f5a-7955e8895156}{75}"
                                            paraid={1183201897}
                                            style={{ textAlign: "center" }}
                                          >
                                            <strong>
                                              Mieux comprendre l’autisme grâce à
                                              l’immersion
                                            </strong>
                                          </p>
                                          <p
                                            paraeid="{dd4eb9d3-0761-4f69-9f5a-7955e8895156}{75}"
                                            paraid={1183201897}
                                          >
                                            Dans le cadre de la 2ᵉ semaine de
                                            l’autisme organisée sur le site
                                            Vauban, étudiants et personnels ont
                                            pu participer à des ateliers de
                                            sensibilisation en réalité
                                            virtuelle. En complément des
                                            ciné-débats, tables rondes et
                                            conférences portés par le
                                            laboratoire APSY-v (en partenariat
                                            avec Aspie Family, le CHU de Nîmes
                                            et la MGEN), ces expériences
                                            immersives ont permis d’appréhender
                                            autrement les troubles du spectre de
                                            l’autisme (TSA), en favorisant
                                            l’empathie et la compréhension.
                                          </p>
                                          <p
                                            paraeid="{dd4eb9d3-0761-4f69-9f5a-7955e8895156}{75}"
                                            paraid={1183201897}
                                            style={{ textAlign: "center" }}
                                          >
                                            <strong>
                                              &nbsp;
                                              <br />
                                              Prévenir les violences sexistes et
                                              sexuelles par l’expérience
                                            </strong>
                                          </p>
                                          <p
                                            paraeid="{dd4eb9d3-0761-4f69-9f5a-7955e8895156}{75}"
                                            paraid={1183201897}
                                          >
                                            Clôturant le mois de l’égalité, les
                                            ateliers annuels de sensibilisation
                                            aux violences sexistes et sexuelles
                                            (VSS), à destination du personnel,
                                            ont une nouvelle fois mobilisé la
                                            réalité virtuelle comme levier
                                            d’impact. En continuité avec les
                                            actions menées aux côtés de
                                            l’association "En Avant Toutes", ces
                                            sessions ont permis d’aborder des
                                            situations concrètes du monde
                                            professionnel et d’encourager la
                                            réflexion, le dialogue et la prise
                                            de conscience.
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnDividerBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnDividerBlockOuter">
                            <tr>
                              <td
                                className="mcnDividerBlockInner"
                                style={{ minWidth: "100%", padding: 18 }}
                              >
                                <table
                                  className="mcnDividerContent"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  width="100%"
                                  style={{
                                    minWidth: "100%",
                                    borderTop: "2px solid #EAEAEA",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <span />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*            
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnCodeBlock"
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td valign="top" className="mcnTextBlockInner">
                                <div className="mcnTextContent">
                                  <h2
                                    style={{
                                      textAling: "left",
                                      fontFamily: '"helvetica"',
                                      textTransform: "uppercase",
                                      color: "white",
                                      backgroundColor: "#21759c",
                                      padding: "7px 7px 7px 15px",
                                      boxShadow: "0 2px 10px -5px black",
                                    }}
                                  >
                                    On Vous Rappellera !
                                  </h2>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p style={{ textAlign: "center" }}>
                                            <span style={{ color: "#e84e24" }}>
                                              <strong>
                                                <span style={{ fontSize: 19 }}>
                                                  On Vous Rappellera s’agrandit
                                                  !
                                                </span>
                                              </strong>
                                            </span>
                                          </p>
                                          <p>
                                            Fort de son succès, notre jeu dédié
                                            à la préparation aux entretiens
                                            d’embauche franchit une nouvelle
                                            étape.{" "}
                                            <strong>
                                              De nouveaux chapitres sont
                                              actuellement en cours de
                                              développement, avec des
                                              thématiques élargies : recherche
                                              de stage, alternance ou encore
                                              entrée en formation.
                                            </strong>
                                            .
                                          </p>
                                          <p>
                                            <strong>
                                              L’expérience évolue aussi en
                                              profondeur :
                                            </strong>{" "}
                                            nouveaux personnages à rencontrer,
                                            interface des retours repensée,
                                            accessibilité améliorée et niveau de
                                            difficulté ajusté pour un parcours
                                            encore plus riche et adapté à tous.{" "}
                                            <strong>
                                              Une chose est sûre : le jeu n’a
                                              pas fini de vous surprendre !
                                            </strong>
                                          </p>
                                          <p>
                                            <strong>
                                              En attendant d'en voir davantage,
                                              nous vous proposons de découvrir
                                              un premier croquis de travail en
                                              avant-première…Mais attention, ça
                                              reste entre nous !
                                            </strong>
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnImageBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnImageBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                style={{ padding: 9 }}
                                className="mcnImageBlockInner"
                              >
                                <table
                                  align="left"
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnImageContentContainer"
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="mcnImageContent"
                                        valign="top"
                                        style={{
                                          paddingRight: 9,
                                          paddingLeft: 9,
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          align="center"
                                          alt=""
                                          src="https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/5603dc02-2170-d769-daf7-c087ec673c0c.png"
                                          width={564}
                                          style={{
                                            maxWidth: 1230,
                                            paddingBottom: 0,
                                            display: "inline !important",
                                            verticalAlign: "bottom",
                                          }}
                                          className="mcnImage"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnDividerBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnDividerBlockOuter">
                            <tr>
                              <td
                                className="mcnDividerBlockInner"
                                style={{ minWidth: "100%", padding: 18 }}
                              >
                                <table
                                  className="mcnDividerContent"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  width="100%"
                                  style={{
                                    minWidth: "100%",
                                    borderTop: "2px solid #EAEAEA",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <span />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*            
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnCodeBlock"
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td valign="top" className="mcnTextBlockInner">
                                <div className="mcnTextContent">
                                  <h2
                                    style={{
                                      textAling: "left",
                                      fontFamily: '"helvetica"',
                                      textTransform: "uppercase",
                                      color: "white",
                                      backgroundColor: "#21759c",
                                      padding: "7px 7px 7px 15px",
                                      boxShadow: "0 2px 10px -5px black",
                                    }}
                                  >
                                    e-campus : nouvel Espace formation
                                  </h2>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnImageBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnImageBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                style={{ padding: 9 }}
                                className="mcnImageBlockInner"
                              >
                                <table
                                  align="left"
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnImageContentContainer"
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="mcnImageContent"
                                        valign="top"
                                        style={{
                                          paddingRight: 9,
                                          paddingLeft: 9,
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          align="center"
                                          alt=""
                                          src="https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/8292c0a0-cc3a-a903-d965-5c42dc1e6130.png"
                                          width={564}
                                          style={{
                                            maxWidth: 1280,
                                            paddingBottom: 0,
                                            display: "inline !important",
                                            verticalAlign: "bottom",
                                          }}
                                          className="mcnImage"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p style={{ textAlign: "center" }}>
                                            <span style={{ color: "#e84e24" }}>
                                              <strong>
                                                <span style={{ fontSize: 19 }}>
                                                  L’espace formation disponible
                                                  sur e-campus fait peau neuve !
                                                </span>
                                              </strong>
                                            </span>
                                          </p>
                                          <p
                                            paraeid="{dd4eb9d3-0761-4f69-9f5a-7955e8895156}{248}"
                                            paraid={750168910}
                                          >
                                            Désormais organisés en 4 grandes
                                            familles, cet espace vous permet
                                            de&nbsp;consulter :&nbsp;
                                          </p>
                                          <ul role="list">
                                            <li
                                              aria-setsize={-1}
                                              data-aria-level={1}
                                              data-aria-posinset={0}
                                              data-font="Calibri"
                                              data-leveltext="-"
                                              data-list-defn-props='{"335551671":0,"335552541":1,"335559685":720,"335559991":360,"469769226":"Calibri","469769242":[8226],"469777803":"left","469777804":"-","469777815":"hybridMultilevel"}'
                                              data-listid={2}
                                              role="listitem"
                                            >
                                              <p
                                                paraeid="{d2e74450-8517-49f6-b40a-4f02c999ef13}{7}"
                                                paraid={670110673}
                                              >
                                                <strong>
                                                  des&nbsp;tutoriels
                                                </strong>
                                                &nbsp;pour vous permettre
                                                d'utiliser au mieux les
                                                fonctionnalités de
                                                e-campus,&nbsp;ses outils dédiés
                                                et les outils numériques mis à
                                                votre disposition par Nîmes
                                                Université.&nbsp;
                                              </p>
                                            </li>
                                          </ul>
                                          <ul role="list">
                                            <li
                                              aria-setsize={-1}
                                              data-aria-level={1}
                                              data-aria-posinset={1}
                                              data-font="Calibri"
                                              data-leveltext="-"
                                              data-list-defn-props='{"335551671":0,"335552541":1,"335559685":720,"335559991":360,"469769226":"Calibri","469769242":[8226],"469777803":"left","469777804":"-","469777815":"hybridMultilevel"}'
                                              data-listid={2}
                                              role="listitem"
                                            >
                                              <p
                                                paraeid="{d2e74450-8517-49f6-b40a-4f02c999ef13}{19}"
                                                paraid={466292345}
                                              >
                                                <strong>
                                                  des&nbsp;formations&nbsp;et
                                                  conseils
                                                </strong>{" "}
                                                à destination des enseignantes
                                                et enseignants souhaitant
                                                adopter d'autres modalité
                                                d'enseignement (hybride,
                                                distanciel, asynchrone...)&nbsp;
                                              </p>
                                            </li>
                                          </ul>
                                          <ul role="list">
                                            <li
                                              aria-setsize={-1}
                                              data-aria-level={1}
                                              data-aria-posinset={2}
                                              data-font="Calibri"
                                              data-leveltext="-"
                                              data-list-defn-props='{"335551671":0,"335552541":1,"335559685":720,"335559991":360,"469769226":"Calibri","469769242":[8226],"469777803":"left","469777804":"-","469777815":"hybridMultilevel"}'
                                              data-listid={2}
                                              role="listitem"
                                            >
                                              <p
                                                paraeid="{d2e74450-8517-49f6-b40a-4f02c999ef13}{27}"
                                                paraid={191965213}
                                              >
                                                <strong>
                                                  des&nbsp;modules
                                                  d'apprentissage
                                                </strong>
                                                &nbsp;conçus pour vous permettre
                                                de produire dans les meilleures
                                                conditions des images, audios,
                                                vidéos et montages dynamiques
                                                pour enrichir vos
                                                enseignements.&nbsp;
                                              </p>
                                            </li>
                                          </ul>
                                          <ul role="list">
                                            <li
                                              aria-setsize={-1}
                                              data-aria-level={1}
                                              data-aria-posinset={3}
                                              data-font="Calibri"
                                              data-leveltext="-"
                                              data-list-defn-props='{"335551671":0,"335552541":1,"335559685":720,"335559991":360,"469769226":"Calibri","469769242":[8226],"469777803":"left","469777804":"-","469777815":"hybridMultilevel"}'
                                              data-listid={2}
                                              role="listitem"
                                            >
                                              <p
                                                paraeid="{d2e74450-8517-49f6-b40a-4f02c999ef13}{35}"
                                                paraid={1886732950}
                                              >
                                                <strong>
                                                  des&nbsp;fiches
                                                  téléchargeables&nbsp;pour
                                                  utiliser l'intelligence
                                                  artificielle générative
                                                </strong>
                                                &nbsp;afin de planifier,
                                                concevoir et donner vos cours,
                                                ainsi que pour faciliter
                                                l'évaluation des
                                                apprentissages.&nbsp;
                                              </p>
                                            </li>
                                          </ul>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnButtonBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnButtonBlockOuter">
                            <tr>
                              <td
                                style={{
                                  paddingTop: 0,
                                  paddingRight: 18,
                                  paddingBottom: 18,
                                  paddingLeft: 18,
                                }}
                                valign="top"
                                align="center"
                                className="mcnButtonBlockInner"
                              >
                                <table
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnButtonContentContainer"
                                  style={{
                                    borderCollapse: "separate !important",
                                    borderRadius: 6,
                                    backgroundColor: "#E84E24",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="center"
                                        valign="middle"
                                        className="mcnButtonContent"
                                        style={{
                                          fontFamily: "Arial",
                                          fontSize: 24,
                                          padding: 18,
                                        }}
                                      >
                                        <a
                                          className="mcnButton "
                                          title="Découvrir l'espace de formation"
                                          href="https://ecampus.unimes.fr/course/index.php?categoryid=1035"
                                          target="_blank"
                                          style={{
                                            fontWeight: "normal",
                                            letterSpacing: "normal",
                                            lineHeight: "100%",
                                            textAlign: "center",
                                            textDecoration: "none",
                                            color: "#FFFFFF",
                                          }}
                                        >
                                          Découvrir l'espace de formation
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnDividerBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnDividerBlockOuter">
                            <tr>
                              <td
                                className="mcnDividerBlockInner"
                                style={{ minWidth: "100%", padding: 18 }}
                              >
                                <table
                                  className="mcnDividerContent"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  width="100%"
                                  style={{
                                    minWidth: "100%",
                                    borderTop: "2px solid #EAEAEA",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <span />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*            
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnCodeBlock"
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td valign="top" className="mcnTextBlockInner">
                                <div className="mcnTextContent">
                                  <h2
                                    style={{
                                      textAling: "left",
                                      fontFamily: '"helvetica"',
                                      textTransform: "uppercase",
                                      color: "white",
                                      backgroundColor: "#21759c",
                                      padding: "7px 7px 7px 15px",
                                      boxShadow: "0 2px 10px -5px black",
                                    }}
                                  >
                                    Mardi de la réussite{" "}
                                  </h2>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnImageBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnImageBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                style={{ padding: 9 }}
                                className="mcnImageBlockInner"
                              >
                                <table
                                  align="left"
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnImageContentContainer"
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="mcnImageContent"
                                        valign="top"
                                        style={{
                                          paddingRight: 9,
                                          paddingLeft: 9,
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          align="center"
                                          alt=""
                                          src="https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/073b5247-414e-2db6-5bc5-39d38de3ca5e.png"
                                          width={564}
                                          style={{
                                            maxWidth: 1191,
                                            paddingBottom: 0,
                                            display: "inline !important",
                                            verticalAlign: "bottom",
                                          }}
                                          className="mcnImage"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p style={{ textAlign: "justify" }}>
                                            Le sixième webinaire mensuel des
                                            Mardis de la réussite&nbsp;a
                                            reçu&nbsp;Joshua&nbsp;Fonti,&nbsp;Ingénieur&nbsp;pour
                                            l’enseignement au sein du SNAP
                                            et&nbsp;doctorant au laboratoire
                                            LHUMAIN pour des échanges sur
                                            <strong>
                                              {" "}
                                              les évaluations et pratiques
                                              pédagogiques dans le supérieur :
                                              créer un cadre pour optimiser la
                                              réussite&nbsp;
                                            </strong>
                                            .
                                          </p>
                                          <p
                                            paraeid="{d2e74450-8517-49f6-b40a-4f02c999ef13}{84}"
                                            paraid={1999440603}
                                          >
                                            Dans le cadre du dispositif "Aide à
                                            la Réussite",
                                            Patrizia&nbsp;Giannoni, chargée de
                                            mission, vous&nbsp;propose ainsi
                                            chaque mois un&nbsp;épisode&nbsp;en
                                            compagnie d’un invité afin
                                            de&nbsp;partager des réflexions et
                                            des conseils autour de la réussite
                                            étudiante.&nbsp;
                                          </p>
                                          <p
                                            paraeid="{d2e74450-8517-49f6-b40a-4f02c999ef13}{98}"
                                            paraid={1321036177}
                                            style={{ textAlign: "center" }}
                                          >
                                            <strong>
                                              Les webinaires sont
                                              disponibles&nbsp;en&nbsp;replay&nbsp;sur
                                              la Web TV de Nîmes
                                              Université&nbsp;
                                            </strong>
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnButtonBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnButtonBlockOuter">
                            <tr>
                              <td
                                style={{
                                  paddingTop: 0,
                                  paddingRight: 18,
                                  paddingBottom: 18,
                                  paddingLeft: 18,
                                }}
                                valign="top"
                                align="center"
                                className="mcnButtonBlockInner"
                              >
                                <table
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnButtonContentContainer"
                                  style={{
                                    borderCollapse: "separate !important",
                                    borderRadius: 6,
                                    backgroundColor: "#E84E24",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="center"
                                        valign="middle"
                                        className="mcnButtonContent"
                                        style={{
                                          fontFamily: "Arial",
                                          fontSize: 24,
                                          padding: 18,
                                        }}
                                      >
                                        <a
                                          className="mcnButton "
                                          title="Découvrir le replay"
                                          href="https://webtv.unimes.fr/videos/joshua-fonti-_-evaluations-et-pratiques-pedagogiques-dans-le-superieur/"
                                          target="_blank"
                                          style={{
                                            fontWeight: "normal",
                                            letterSpacing: "normal",
                                            lineHeight: "100%",
                                            textAlign: "center",
                                            textDecoration: "none",
                                            color: "#FFFFFF",
                                          }}
                                        >
                                          Découvrir le replay
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnDividerBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnDividerBlockOuter">
                            <tr>
                              <td
                                className="mcnDividerBlockInner"
                                style={{ minWidth: "100%", padding: 18 }}
                              >
                                <table
                                  className="mcnDividerContent"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  width="100%"
                                  style={{
                                    minWidth: "100%",
                                    borderTop: "2px solid #EAEAEA",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <span />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*            
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnCodeBlock"
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td valign="top" className="mcnTextBlockInner">
                                <div className="mcnTextContent">
                                  <h2
                                    style={{
                                      textAling: "left",
                                      fontFamily: '"helvetica"',
                                      textTransform: "uppercase",
                                      color: "white",
                                      backgroundColor: "#21759c",
                                      padding: "7px 7px 7px 15px",
                                      boxShadow: "0 2px 10px -5px black",
                                    }}
                                  >
                                    Le SNAP au cœur des échanges sur l’IA
                                  </h2>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnImageBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnImageBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                style={{ padding: 9 }}
                                className="mcnImageBlockInner"
                              >
                                <table
                                  align="left"
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnImageContentContainer"
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="mcnImageContent"
                                        valign="top"
                                        style={{
                                          paddingRight: 9,
                                          paddingLeft: 9,
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          align="center"
                                          alt=""
                                          src="https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/ba74993e-584b-6810-06d4-7e24568b9435.jpg"
                                          width={564}
                                          style={{
                                            maxWidth: 885,
                                            paddingBottom: 0,
                                            display: "inline !important",
                                            verticalAlign: "bottom",
                                          }}
                                          className="mcnImage"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p>
                                            Le mercredi 11 mars, le SNAP est
                                            intervenu auprès des enseignants du
                                            Lycée Philippe Lamour à Nîmes pour{" "}
                                            <strong>
                                              un temps d’échange consacré aux
                                              usages de l’intelligence
                                              artificielle en contexte
                                              pédagogique.
                                            </strong>
                                          </p>
                                          <p>
                                            <strong>Au programme :</strong>{" "}
                                            partage de pratiques, retours
                                            d’expérience et réflexion collective
                                            autour des enjeux actuels.
                                            L’installation d’outils en local, la
                                            sécurisation des données ou encore
                                            l’utilisation de la génération
                                            augmentée par récupération de
                                            documents (RAG) ont particulièrement
                                            nourri les discussions.
                                          </p>
                                          <p>
                                            Au-delà des aspects techniques, ces
                                            échanges ont également permis
                                            d’interroger la place des
                                            enseignants face à ces évolutions,
                                            avec un objectif commun :{" "}
                                            <strong>
                                              favoriser des conditions de
                                              réussite optimales pour les élèves
                                              et étudiants du territoire.
                                            </strong>
                                          </p>
                                          <p>
                                            Nous remercions chaleureusement M.
                                            Molle (ingénieur de formation
                                            EAFC-ING), M. Dimeur (proviseur du
                                            Lycée Philippe Lamour) ainsi que
                                            Caroline Smagghe (enseignante et
                                            chargée de mission Relation
                                            École-Économie) pour leur accueil et
                                            la qualité de la coordination.
                                            <br />
                                            &nbsp;
                                          </p>
                                          <p style={{ textAlign: "center" }}>
                                            <strong>
                                              Des formations à venir
                                            </strong>
                                          </p>
                                          <p>
                                            <strong>
                                              Dans cette dynamique, le SNAP
                                              proposera prochainement des
                                              formations dédiées à l’intégration
                                              de l’IA dans les pratiques
                                              d’enseignement.
                                            </strong>
                                            <br />
                                            Elles aborderont notamment :
                                          </p>
                                          <ul>
                                            <li>
                                              la planification pédagogique avec
                                              l’IA
                                            </li>
                                            <li>
                                              la conception de ressources
                                              pédagogiques
                                            </li>
                                            <li>les modalités d’évaluation</li>
                                            <li>
                                              l’animation de la classe avec l’IA
                                            </li>
                                          </ul>
                                          <p>
                                            <strong>Objectif : </strong>
                                            accompagner concrètement les
                                            enseignants dans l’appropriation de
                                            ces outils et soutenir leurs
                                            activités pédagogiques au quotidien.
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnDividerBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnDividerBlockOuter">
                            <tr>
                              <td
                                className="mcnDividerBlockInner"
                                style={{ minWidth: "100%", padding: 18 }}
                              >
                                <table
                                  className="mcnDividerContent"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  width="100%"
                                  style={{
                                    minWidth: "100%",
                                    borderTop: "2px solid #EAEAEA",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <span />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*            
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p>
                                            <strong>
                                              Des idées à partager ? Des besoins
                                              particuliers ?
                                            </strong>
                                            <br />
                                            <br />
                                            Le SNAP est là pour échanger avec
                                            vous sur vos projets, vous
                                            conseiller et vous apporter un
                                            soutien technique et méthodologique.
                                          </p>
                                          <p>
                                            <strong>
                                              Restons en contact !
                                            </strong>
                                            <br />
                                            <br />
                                            Vous pouvez également nous
                                            solliciter&nbsp;via le site&nbsp;
                                            <a
                                              rel="noreferrer noopener"
                                              target="_blank"
                                            >
                                              snap.unimes.fr
                                            </a>
                                            , par mail à&nbsp;
                                            <a
                                              rel="noreferrer noopener"
                                              target="_blank"
                                            >
                                              <strong>snap@unimes.fr</strong>
                                            </a>
                                            , ou par téléphone au&nbsp;
                                            <strong>04 66 36 46 28</strong>.
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top" id="templateFooter">
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <h4 style={{ textAlign: "center" }}>
                                            <span style={{ fontSize: 18 }}>
                                              Service Numérique &amp;
                                              Accompagnement Pédagogique (SNAP)
                                            </span>
                                          </h4>
                                          <p style={{ textAlign: "center" }}>
                                            <span style={{ fontSize: 18 }}>
                                              Nîmes&nbsp;Université - Site
                                              Vauban - Bat D, bureaux&nbsp;D121
                                              et&nbsp;D119 - Rue du Dr Georges
                                              Salan - CS13019 30021 Nîmes Cedex
                                              01
                                            </span>
                                          </p>
                                          <p style={{ textAlign: "center" }}>
                                            <span style={{ fontSize: 18 }}>
                                              &nbsp;04 66 36 46 28
                                            </span>
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnFollowBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnFollowBlockOuter">
                            <tr>
                              <td
                                align="center"
                                valign="top"
                                style={{ padding: 9 }}
                                className="mcnFollowBlockInner"
                              >
                                <table
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="center"
                                        style={{
                                          paddingLeft: 9,
                                          paddingRight: 9,
                                        }}
                                      >
                                        <table
                                          border={0}
                                          cellPadding={0}
                                          cellSpacing={0}
                                          width="100%"
                                          style={{ minWidth: "100%" }}
                                          className="mcnFollowContentContainer"
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                valign="top"
                                                style={{ padding: 10 }}
                                                className="mcnFollowContent"
                                              >
                                                <table
                                                  border={0}
                                                  cellPadding={0}
                                                  cellSpacing={0}
                                                >
                                                  <tbody>
                                                    <tr>
                                                      <td
                                                        align="left"
                                                        valign="top"
                                                      >
                                                        <table
                                                          border={0}
                                                          cellPadding={0}
                                                          cellSpacing={0}
                                                          width="100%"
                                                          className="mcnFollowContentItem"
                                                        >
                                                          <tbody>
                                                            <tr>
                                                              <td
                                                                align="left"
                                                                valign="top"
                                                                width={24}
                                                                style={{
                                                                  paddingRight: 5,
                                                                  paddingLeft: 0,
                                                                  paddingBottom: 10,
                                                                }}
                                                                className="mcnFollowIconContent"
                                                              >
                                                                <a
                                                                  href="mailto:snap@unimes.fr"
                                                                  target="_blank"
                                                                >
                                                                  <img
                                                                    src="https://cdn-images.mailchimp.com/icons/social-block-v2/outline-color-forwardtofriend-48.png"
                                                                    alt="Notre e-mail"
                                                                    height={24}
                                                                    width={24}
                                                                    style={{
                                                                      display:
                                                                        "block",
                                                                    }}
                                                                  />
                                                                </a>
                                                              </td>
                                                              <td
                                                                valign="middle"
                                                                className="mcnFollowTextContent"
                                                                style={{
                                                                  paddingLeft: 0,
                                                                  paddingBottom: 10,
                                                                }}
                                                              >
                                                                <a
                                                                  href="mailto:snap@unimes.fr"
                                                                  target="_blank"
                                                                  style={{
                                                                    color:
                                                                      "#656565",
                                                                  }}
                                                                >
                                                                  Notre e-mail
                                                                </a>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                        <table
                                                          border={0}
                                                          cellPadding={0}
                                                          cellSpacing={0}
                                                          width="100%"
                                                          className="mcnFollowContentItem"
                                                        >
                                                          <tbody>
                                                            <tr>
                                                              <td
                                                                align="left"
                                                                valign="top"
                                                                width={24}
                                                                style={{
                                                                  paddingRight: 5,
                                                                  paddingLeft: 0,
                                                                  paddingBottom: 10,
                                                                }}
                                                                className="mcnFollowIconContent"
                                                              >
                                                                <a
                                                                  href="https://snap.unimes.fr/"
                                                                  target="_blank"
                                                                >
                                                                  <img
                                                                    src="https://cdn-images.mailchimp.com/icons/social-block-v2/outline-color-link-48.png"
                                                                    alt="Notre site"
                                                                    height={24}
                                                                    width={24}
                                                                    style={{
                                                                      display:
                                                                        "block",
                                                                    }}
                                                                  />
                                                                </a>
                                                              </td>
                                                              <td
                                                                valign="middle"
                                                                className="mcnFollowTextContent"
                                                                style={{
                                                                  paddingLeft: 0,
                                                                  paddingBottom: 10,
                                                                }}
                                                              >
                                                                <a
                                                                  href="https://snap.unimes.fr/"
                                                                  target="_blank"
                                                                  style={{
                                                                    color:
                                                                      "#656565",
                                                                  }}
                                                                >
                                                                  Notre site
                                                                </a>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                        <table
                                                          border={0}
                                                          cellPadding={0}
                                                          cellSpacing={0}
                                                          width="100%"
                                                          className="mcnFollowContentItem"
                                                        >
                                                          <tbody>
                                                            <tr>
                                                              <td
                                                                align="left"
                                                                valign="top"
                                                                width={24}
                                                                style={{
                                                                  paddingRight: 5,
                                                                  paddingLeft: 0,
                                                                  paddingBottom: 0,
                                                                }}
                                                                className="mcnFollowIconContent"
                                                              >
                                                                <a
                                                                  href="https://demat.unimes.fr/snap"
                                                                  target="_blank"
                                                                >
                                                                  <img
                                                                    src="https://cdn-images.mailchimp.com/icons/social-block-v2/outline-color-link-48.png"
                                                                    alt="Formulaire d'assistance"
                                                                    height={24}
                                                                    width={24}
                                                                    style={{
                                                                      display:
                                                                        "block",
                                                                    }}
                                                                  />
                                                                </a>
                                                              </td>
                                                              <td
                                                                valign="middle"
                                                                className="mcnFollowTextContent"
                                                                style={{
                                                                  paddingLeft: 0,
                                                                  paddingBottom: 0,
                                                                }}
                                                              >
                                                                <a
                                                                  href="https://mes-demarches.unimes.fr/snap/"
                                                                  target="_blank"
                                                                  style={{
                                                                    color:
                                                                      "#656565",
                                                                  }}
                                                                >
                                                                  Formulaire
                                                                  d'assistance
                                                                </a>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnDividerBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnDividerBlockOuter">
                            <tr>
                              <td
                                className="mcnDividerBlockInner"
                                style={{ minWidth: "100%", padding: 18 }}
                              >
                                <table
                                  className="mcnDividerContent"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  width="100%"
                                  style={{
                                    minWidth: "100%",
                                    borderTop: "2px solid #EAEAEA",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <span />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*            
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                {/*[if (gte mso 9)|(IE)]>
                  </td>
                  </tr>
                  </table>
                  <![endif]*/}
                {/* // END TEMPLATE */}
              </td>
            </tr>
          </tbody>
        </table>
      </center>
    </>
  );
}
